import React, { useState, useContext } from "react";
import styled from "styled-components";
import {
    LottieLoadingIndicator,
    StandardModal,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalFormGroup,
    StandardModalSection,
    StandardModalSectionTitle,
    Toast,
    FormField
} from "src/components";
import { GetManageButton } from "src/scenes/MyQuotes/components/style";
import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserContext } from "src/scenes/App/UserContext";

const StyledTitleInput = styled(FormField)`
    border: 1px solid #8291b2;
    border-radius: 12px;
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #000;
    width: min(100%, 364px);
    height: 50px;

    ::placeholder {
        text-align: left;
        color: #808080;
        font-family: Manrope, Helvetica, sans-serif;
    }
`;

export default function ChangeNameDialog(props) {
    const userContext = useContext(UserContext);
    const { hideShowNameChangeDialog, featureName } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [customName, setCustomName] = useState(featureName);
    const onSubmit = async () => {
        setIsLoading(true);
        try {
            await axios.put(`${API_URL}/company/clientLicense/customName`, {
                name: customName
            }, {
                headers: {
                    Authorization: "Bearer " + props.token
                }
            });
            userContext.appFns.updateUserContextProperties({
                customSalesAndPromotionsName: customName
            });
            hideShowNameChangeDialog();
        } catch (error) {
            console.log(error);
            Toast.error(error.getApiErrorDetails().message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <StandardModal
            open={true}
            onClose={hideShowNameChangeDialog}
            widthMode="large"
            title="Change Sales & Promotions Feature Name"
            description="Rename the Sales & Promotions feature in the Me Business app and portal to better match your business or community. This custom name will replace the default label ‘Sales & Promotions’ wherever it appears."
            footer={(
                <StandardModalActionGroup $pushRight>
                    <GetManageButton
                        type="button"
                        onClick={() => hideShowNameChangeDialog()}
                        style={{
                            width: "140px",
                            height: "38px",
                            backgroundColor: "#FFFFFF",
                            color: "black",
                            border: "1px solid #000000",
                        }}
                    >
                        Cancel
                    </GetManageButton>
                    <GetManageButton
                        type="submit"
                        style={{
                            width: "140px",
                            height: "38px",
                            backgroundColor: "#171A22"
                        }}
                        onClick={() => onSubmit()}
                        disabled={isLoading}
                    >
                        {isLoading ? <LottieLoadingIndicator height="28px" width="28px" containerHeight="28px" margin="0" /> : "Save"}
                    </GetManageButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalFormGroup>
                    <StandardModalSectionTitle>Set a Custom Name (Optional)</StandardModalSectionTitle>
                    <StandardModalDescription>
                        Enter a new name for this feature. If left blank, it will continue to appear as ‘Sales & Promotions’.
                    </StandardModalDescription>
                    <StyledTitleInput
                        name="CustomSalesPromotionsName"
                        value={customName}
                        placeholder="e.g. Daily Inspiration"
                        onChange={(e) => setCustomName(e.target.value || "")}
                    />
                </StandardModalFormGroup>
            </StandardModalSection>
        </StandardModal>
    );
}
